var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_27721)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 11.6374C7.62198 11.6374 4.74626 14.9623 4.74626 19.2491C4.74626 19.5023 4.54105 19.7075 4.28792 19.7075C4.03479 19.7075 3.82959 19.5023 3.82959 19.2491C3.82959 14.6214 6.96491 10.7207 11.0002 10.7207C15.0355 10.7207 18.1708 14.6214 18.1708 19.2491C18.1708 19.5023 17.9656 19.7075 17.7125 19.7075C17.4594 19.7075 17.2542 19.5023 17.2542 19.2491C17.2542 14.9623 14.3784 11.6374 11.0002 11.6374Z",
    fill: "#08081B",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.68815C10.3412 3.68815 9.69725 3.88351 9.14948 4.24952C8.60171 4.61552 8.17477 5.13574 7.92266 5.74439C7.67055 6.35304 7.60459 7.02278 7.73311 7.66892C7.86164 8.31506 8.17888 8.90858 8.64472 9.37442C9.11056 9.84026 9.70407 10.1575 10.3502 10.286C10.9964 10.4145 11.6661 10.3486 12.2747 10.0965C12.8834 9.84436 13.4036 9.41743 13.7696 8.86966C14.1356 8.32189 14.331 7.67789 14.331 7.01909V3.68815H11ZM8.6402 3.48733C9.33872 3.0206 10.16 2.77148 11 2.77148H15.2477V7.01909C15.2477 7.85919 14.9985 8.68042 14.5318 9.37893C14.0651 10.0774 13.4017 10.6219 12.6255 10.9434C11.8494 11.2649 10.9953 11.349 10.1714 11.1851C9.34743 11.0212 8.59058 10.6166 7.99654 10.0226C7.4025 9.42856 6.99795 8.67171 6.83406 7.84775C6.67017 7.0238 6.75428 6.16975 7.07577 5.3936C7.39726 4.61745 7.94169 3.95407 8.6402 3.48733Z",
    fill: "#08081B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_27721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Profile.6847434105b644ca3adda4315220a385.svg";